import Http from '../../../../network/Http'
import {NatGetAccountingTerms} from './NatGetAccountingTerms'
import {NatGetAssocWorkReportPlanResults} from './NatGetAssocWorkReportPlanResults'
import {NatGetNextTermReports} from './NatGetNextTermReports'
import {NatGetAssocInfos} from './NatGetAssocInfos'
import {NatGetAssocList} from './NatGetAssocList'
import {NatPutReportPublishingSettingRequest} from './NatPutReportPublishingSetting'
import {ApiResponse} from '../../../../network/response/ApiResponse'

export class NatAssocWorkReportRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    async getAccountingTerms(condominiumCd: string, assocCd: string): Promise<NatGetAccountingTerms> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/assocs/${assocCd}/work-reports/accounting-terms`
        )
    }

    async getAssocWorkReportPlanResults(
        condominiumCd: string,
        assocCd: string,
        accountingTermKey: string
    ): Promise<NatGetAssocWorkReportPlanResults> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/assocs/${assocCd}/work-reports/plan-result?accountingTermKey=${accountingTermKey}`
        )
    }

    async getNextTermReports(condominiumCd: string, assocCd: string,): Promise<NatGetNextTermReports> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/assocs/${assocCd}/work-reports/next-term-reports`
        )
    }

    async getAssocs(condominiumCd: string): Promise<NatGetAssocInfos> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/assocs`
        )
    }

    async getAssocList(condominiumCd: string): Promise<NatGetAssocList> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/assocs`
        )
    }

    async getAssocListForChairman(condominiumCd: string): Promise<NatGetAssocList> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/assocs/chairman`
        )
    }

    async updateReportPublishingSetting(
        condominiumCd: string,
        assocId: number,
        requestParam: NatPutReportPublishingSettingRequest
    ): Promise<void> {
        return await this.http.put(
            `/api/admin/condominiums/${condominiumCd}/assocs/${assocId}/report-publishing-setting`,
            requestParam,
        )
    }

    async getMergedByYearMonthFileNumber(
        condominiumCd: string,
        assocCd: string,
        accountingKey: string,
        targetYearMonth: string,
    ): Promise<number> {
        const queryParameter = `?accountingKey=${accountingKey}&targetYearMonth=${targetYearMonth}`

        const apiResponseJSON: ApiResponse<number> = await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/assocs/${assocCd}/work-reports/merged-file-by-yearmonth${queryParameter}`,
        )

        return apiResponseJSON.details
    }

    async getMergedByWorkingCdFileNumber(
        condominiumCd: string,
        assocCd: string,
        accountingKey: string,
        targetWorkingCd: string,
    ): Promise<number> {
        const queryParameter = `?accountingKey=${accountingKey}&targetWorkCd=${targetWorkingCd}`

        const apiResponseJSON: ApiResponse<number> = await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/assocs/${assocCd}/work-reports/merged-file-by-work${queryParameter}`,
        )

        return apiResponseJSON.details
    }
}
